module.exports = __webpack_public_path__ + "img/flavor3.3a89633e.png";